import EntradasComponent from "../Component/EntradasComponent"
import HeaderComponent from "../Component/HeaderComponent"
import SidebarComponent from "../Component/SidebarComponent"
import calendarIcon from '../Assets/icons/calendarIcon.svg'
import SaidasComponent from "../Component/SaidasComponent"
import { useEffect, useState } from "react"
import { data, useLocation } from "react-router-dom"
import DatePicker from "react-datepicker";
import axiosInstance from "../Services/Api"
import ComprovanteModal from "../Component/ComprovanteModal"
import AffiliateComponent from "../Component/AffiliateComponent"
import { getUserdata } from '../Helper'

const RelatorioPage = () => {
    const [type, setType] = useState(null)
    const location = useLocation();
    const [pageCounts, setPageCounts] = useState(1);
    const [actualPage, setActualPage] = useState(1)
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [sidebarOpen, setSiidebarOpen] = useState(false)
    const [startPage, setStartPage] = useState(1);
    const [relatories, setRelatories] = useState([])
    const [comprovanteOpen, setComprovanteOpen] = useState(false)
    const [comprovanteData, setComprovanteData] = useState(null)
    const [userData, setUserData] = useState(null);
    
    const setSidebarOpen = (bool) => {
        window.localStorage.setItem('sidebarIsOpen', JSON.stringify(bool))
        setSiidebarOpen(bool)
    }

    useEffect(() => {
        const localSidebarStorage = JSON.parse(window.localStorage.getItem('sidebarIsOpen'))
        setSiidebarOpen(localSidebarStorage)
    }, [])
    useEffect(() => {
        getRelatorie(1)
        setStartDate(null)
        setEndDate(null)
    }, [location.search]);
    const getRelatorie = async (page, startDate, endDate) => {

        //garantindo gerar os dados do user apos setar o filtro
        (async () => {
            const data = await getUserdata(startDate, endDate)
            console.log(data)
            setUserData(data)
        })()
        setRelatories([])
        const queryParams = new URLSearchParams(location.search);
        const filterType = queryParams.get('filter');
        const type = filterType ? filterType : 'entries';
        setType(type)
        if (startDate !== null || endDate !== null) {
            const startDateString = startDate ? new Date(startDate).toISOString().split('T')[0] : '';
            const endDateString = endDate ? new Date(endDate).toISOString().split('T')[0] : '';
            try {
                let param
                console.log(type)
                switch (type) {
                    case 'entries':
                        param = 'e'
                        break;
                    case 'exits':
                        param = 'o'
                        break;
                    case 'affiliates':
                        param = 'a'
                        break;
                }
                console.log(param)
                const response = await axiosInstance.get('/api/relatories', {
                    params: {
                        type: param,
                        page: page,
                        startDate: startDateString,
                        endDate: endDateString,
                    },
                });
                console.log(response.data.data)
                setPageCounts(response.data.last_page);
                setRelatories(response.data.data);
            } catch (e) {
                if (e.status === 401) {
                    window.localStorage.removeItem('token')
                    window.location.reload()
                }
            }
        } else {
            try {
                let param
                console.log(type)
                switch (type) {
                    case 'entries':
                        param = 'e'
                        break;
                    case 'exits':
                        param = 'o'
                        break;
                    case 'affiliates':
                        param = 'a'
                        break;
                }

                console.log(param)
                const response = await axiosInstance.get('/api/relatories', {
                    params: {
                        type: param,
                        page: page,
                    },
                });

                setPageCounts(response.data.last_page);
                setRelatories(response.data.data);
            } catch (e) {
                if (e.status === 401) {
                    window.localStorage.removeItem('token')
                    window.location.reload()
                }
            }
        }


    };

    const handleComprovante = (comprovanteData) => {
        setComprovanteData(comprovanteData)
        setComprovanteOpen(true)
    }
    const handlePageChange = (pageNumber) => {
        setActualPage(pageNumber);
        setRelatories([]);
        getRelatorie(pageNumber)
    };

    const handleNextPages = () => {
        setStartPage(startPage + 4);
    };

    const handlePrevPages = () => {
        setStartPage(startPage - 4);
    };
    const pages = Array.from({ length: pageCounts }, (_, i) => i + 1);
    if (relatories === null) {
        return <div className='w-full h-screen bg-[#171717]'>
            loading...
        </div>
    }

    return (
        <div className="flex w-full h-full min-h-screen  md:h-screen bg-[#171717]">
            <SidebarComponent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className={`${sidebarOpen?'md:ml-[250px]' : 'md:ml-[100px]'}  text-white w-full  md:mt-8`}>
                <HeaderComponent setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} title={'Rletórios'} subTitle={'Seja bem-vindo ao painel de controle da sua empresa'} />
                <div className="w-full overflow-x-auto md:mt-0 mt-10 mb-[50px] md:static relative z-[99999] md:mb-0 px-4 ">
                    <div className={`${type === 'entries' ? '' : 'hidden'}`}>
                        <EntradasComponent userData={userData} setPageCounts={setPageCounts} />
                    </div>
                    <div className={`${type === 'exits' ? '' : 'hidden'}`}>
                        <SaidasComponent userData={userData} />
                    </div>
                    <div className={`${type === 'affiliates' ? '' : 'hidden'}`}>
                        <AffiliateComponent userData={userData} />
                    </div>
                    {type !== 'affiliates' && relatories !== undefined && <>
                        <div className="flex items-center gap-4 mt-3">
                            {/* <div className="flex cursor-pointer text-white gap-3 items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                            <img src={qrCodeIcon} />
                            <p>Adicionar saldo</p>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                            </svg>
                            </div> */}
                            <div className="flex   gap-1 text-white items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                <img src={calendarIcon} />
                                <DatePicker selected={startDate} onChange={(date) => { setStartDate(date); getRelatorie(actualPage, date, endDate) }} className="bg-transparent w-[100px]  cursor-pointer  text-center text-white focus:outline-none" />
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                                </svg>
                            </div>
                            <div className="flex">
                                <svg width="10" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.5 1L0.5 4L3.5 7" stroke="white" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="10" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.500366 7L3.50037 4L0.500367 1" stroke="white" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div className="flex  gap-1 text-white items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                <img src={calendarIcon} />
                                <DatePicker selected={endDate} onChange={(date) => { setEndDate(date); getRelatorie(actualPage, startDate, date) }} className="bg-transparent w-[100px]  cursor-pointer  text-center text-white focus:outline-none" />
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                                </svg>
                            </div>
                        </div>
                        <div className="flex mt-6 items-center gap-4">
                            <p>Mostrando</p>
                            <div className="flex items-center bg-[#478DF8] text-[13px] px-2 rounded-[10px] p-1">
                                {/* <select className="bg-[transparent] focus:outline-none border-[none]">
                                <option>100</option>
                                <option>Todos</option>
                            </select> */}

                                10

                            </div>
                            <p>Registros</p>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full min-w-full md:static relative  z-[9999] overflow-x-auto gap-4 mt-4  gap-4 mt-4">
                                <thead className="text-[14px]  border-b border-[#343B4F] text-left w-full justify-between gap-3 items-center">
                                    {type === 'entries' ? (
                                        <>
                                            <th>Id da transação</th>
                                            <th>EndToEndId</th>
                                        </>
                                    ) : (
                                        <th>Id da transação</th>
                                    )}
                                    <th>Data gerada</th>
                                    <th>Valor</th>
                                    {type === 'entries' ? (
                                        <th>
                                            <div className="text-[white] text-center p-1 w-[100px] rounded-[15px] bg-[#478DF8]">Status</div>
                                        </th>
                                    ) : (
                                        <>
                                            <th>
                                                <div className="text-[white] mb-1 p-1 w-[100px] rounded-[15px] bg-[#478DF8]">Comprovante</div>
                                            </th>
                                            <th>
                                                <div className="text-[white] mb-1 p-1 w-[100px] rounded-[15px] bg-[#478DF8]">Descrição</div>
                                            </th>
                                        </>
                                    )}

                                </thead>
                                <tbody className="min-w-full" style={{ paddingTop: '16px' }}>
                                    <tr className="text-[12px] pt-4 w-full border-[#343B4F]">
                                        <td className="pt-4"></td>
                                        <td className="pt-4"></td>
                                        <td className="pt-4"></td>
                                        <td className="pt-4"></td>
                                    </tr>
                                    {relatories.map((data) => (
                                        <tr key={data.id} className="text-[12px] pt-4 w-full border-[#343B4F]">
                                            {type === 'entries' ? (
                                                <>
                                                    <td>{data.txtId}</td>
                                                    <td>{data.endToEndId}</td>
                                                </>
                                            ) : (
                                                <td>{data.endToEndId}</td>
                                            )}
                                            <td>
                                                {new Date(data.created_at).toLocaleString('pt-BR', {
                                                    timeZone: 'America/Sao_Paulo', // Define o fuso horário de Brasília
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false // Para usar o formato 24 horas
                                                })}
                                            </td>
                                            <td>{data.amount}</td>
                                            {type === 'entries' ? (
                                                <td>
                                                    <div className="text-[#59A8D4] text-center font-bold p-1 w-[100px] rounded-[15px] bg-[#E2F5FF]">{data.status === 1 ? 'aprovado' : (data.status === 0 ? 'pendente' : (data.status === 3 ? 'Estornado' : 'Análise'))}</div>
                                                </td>
                                            ) : (
                                                <>
                                                    <td>
                                                        <div onClick={() => { handleComprovante(data) }} className="text-[#59A8D4] cursor-pointer ml-8 font-bold p-1 w-[100px] rounded-[15px] ">
                                                            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1.40625 5.0937H2.8125V8.8437H1.875C1.75068 8.8437 1.63145 8.89309 1.54354 8.981C1.45564 9.0689 1.40625 9.18813 1.40625 9.31245C1.40625 9.43677 1.45564 9.556 1.54354 9.64391C1.63145 9.73182 1.75068 9.7812 1.875 9.7812H13.125C13.2493 9.7812 13.3685 9.73182 13.4565 9.64391C13.5444 9.556 13.5938 9.43677 13.5938 9.31245C13.5938 9.18813 13.5444 9.0689 13.4565 8.981C13.3685 8.89309 13.2493 8.8437 13.125 8.8437H12.1875V5.0937H13.5938C13.6957 5.0936 13.7949 5.06024 13.8762 4.99867C13.9575 4.93711 14.0166 4.8507 14.0443 4.75256C14.0721 4.65442 14.0671 4.54991 14.0301 4.45487C13.9931 4.35983 13.9261 4.27945 13.8393 4.22593L7.74551 0.475929C7.67167 0.43053 7.58668 0.406494 7.5 0.406494C7.41332 0.406494 7.32833 0.43053 7.25449 0.475929L1.16074 4.22593C1.07392 4.27945 1.00693 4.35983 0.96992 4.45487C0.932912 4.54991 0.927912 4.65442 0.955677 4.75256C0.983442 4.8507 1.04246 4.93711 1.12377 4.99867C1.20508 5.06024 1.30426 5.0936 1.40625 5.0937ZM3.75 5.0937H5.625V8.8437H3.75V5.0937ZM8.4375 5.0937V8.8437H6.5625V5.0937H8.4375ZM11.25 8.8437H9.375V5.0937H11.25V8.8437ZM7.5 1.42515L11.9379 4.1562H3.06211L7.5 1.42515ZM14.5312 11.1875C14.5312 11.3118 14.4819 11.431 14.394 11.5189C14.306 11.6068 14.1868 11.6562 14.0625 11.6562H0.9375C0.81318 11.6562 0.693951 11.6068 0.606044 11.5189C0.518136 11.431 0.46875 11.3118 0.46875 11.1875C0.46875 11.0631 0.518136 10.9439 0.606044 10.856C0.693951 10.7681 0.81318 10.7187 0.9375 10.7187H14.0625C14.1868 10.7187 14.306 10.7681 14.394 10.856C14.4819 10.9439 14.5312 11.0631 14.5312 11.1875Z" fill="#478DF8" />
                                                            </svg>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="text-[#59A8D4] cursor-pointer ml-8 font-bold p-1 w-[100px] rounded-[15px] ">
                                                            {data.description}
                                                        </div>
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="flex justify-between text-[12px] gap-6 items-center w-full mt-4">
                            <p className="text-[12px]">mostrando página {actualPage} de {pageCounts}</p>
                            <div className="flex">
                                {startPage > 4 && (
                                    <button className="mx-1" onClick={handlePrevPages}>
                                        <svg width="8" height="8" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.92541 0.558058C7.19153 0.802136 7.19153 1.19786 6.92541 1.44194L2.4375 5.55806C2.17138 5.80214 2.17138 6.19786 2.4375 6.44194L6.92541 10.5581C7.19153 10.8021 7.19153 11.1979 6.92541 11.4419C6.65928 11.686 6.22781 11.686 5.96169 11.4419L1.47378 7.32583C0.675408 6.59359 0.675406 5.40641 1.47378 4.67418L5.96169 0.558058C6.22781 0.313981 6.65928 0.313981 6.92541 0.558058Z" fill="white" />
                                        </svg>


                                    </button>
                                )}
                                {pages.slice(startPage - 1, startPage + 3).map((page) => (
                                    <button key={page} className={`mx-1 ${page === actualPage ? 'bg-[#478DF8] p-1 px-2 rounded-[10px]' : ''}`} onClick={() => handlePageChange(page)}>
                                        {page}
                                    </button>
                                ))}
                                {startPage + 3 < pageCounts && (
                                    <button className="mx-1" onClick={handleNextPages}>
                                        <svg width="8" height="8" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.07459 11.4419C0.808469 11.1979 0.808469 10.8021 1.07459 10.5581L5.5625 6.44194C5.82863 6.19786 5.82863 5.80214 5.5625 5.55806L1.07459 1.44194C0.80847 1.19786 0.80847 0.802137 1.07459 0.558058C1.34072 0.313981 1.77219 0.313981 2.03831 0.558058L6.52622 4.67418C7.32459 5.40641 7.32459 6.59359 6.52622 7.32582L2.03831 11.4419C1.77219 11.686 1.34072 11.686 1.07459 11.4419Z" fill="white" />
                                        </svg>
                                    </button>
                                )}


                            </div>
                        </div>
                    </>}

                    {
                        type === 'affiliates' && relatories && <>
                            <div className="flex items-center gap-4 mt-3">
                                {/* <div className="flex cursor-pointer text-white gap-3 items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                            <img src={qrCodeIcon} />
                            <p>Adicionar saldo</p>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                            </svg>
                        </div> */}
                                <div className="flex   gap-1 text-white items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                    <img src={calendarIcon} />
                                    <DatePicker selected={startDate} onChange={(date) => { setStartDate(date); getRelatorie(actualPage, date, endDate) }} className="bg-transparent w-[100px]  cursor-pointer  text-center text-white focus:outline-none" />
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                                    </svg>
                                </div>
                                <div className="flex">
                                    <svg width="10" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.5 1L0.5 4L3.5 7" stroke="white" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <svg width="10" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.500366 7L3.50037 4L0.500367 1" stroke="white" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div className="flex  gap-1 text-white items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                    <img src={calendarIcon} />
                                    <DatePicker selected={endDate} onChange={(date) => { setEndDate(date); getRelatorie(actualPage, startDate, date) }} className="bg-transparent w-[100px]  cursor-pointer  text-center text-white focus:outline-none" />
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                                    </svg>
                                </div>
                            </div>
                            <div className="flex mt-6 items-center gap-4">
                                <p>Mostrando</p>
                                <div className="flex items-center bg-[#478DF8] text-[13px] px-2 rounded-[10px] p-1">
                                    {/* <select className="bg-[transparent] focus:outline-none border-[none]">
                                <option>100</option>
                                <option>Todos</option>
                            </select> */}

                                    10

                                </div>
                                <p>Registros</p>
                            </div>
                            <div className="overflow-x-auto">
                                <table className="w-full min-w-full overflow-x-auto gap-4 mt-4  gap-4 mt-4">
                                    <thead className="text-[14px]  border-b border-[#343B4F] text-left w-full justify-between gap-3 items-center">
                                        <th>Nome do usuário</th>
                                        <th>Total de faturamento</th>
                                        <th>Total de depósitos confirmados</th>
                                        <th>Total de depósitos não confirmados</th>

                                    </thead>
                                    <tbody className="min-w-full" style={{ paddingTop: '16px' }}>
                                        <tr className="text-[12px] pt-4 w-full border-[#343B4F]">
                                            <td className="pt-4"></td>
                                            <td className="pt-4"></td>
                                            <td className="pt-4"></td>
                                            <td className="pt-4"></td>
                                        </tr>
                                        {relatories.map((data) => (

                                            <tr key={data.id} className="text-[12px] pt-4 w-full border-[#343B4F]">
                                                <td className="pt-4">{data.name}</td>
                                                <td className="pt-4">{(Number(data.total_depositos) + Number(data.total_depositos_gerados)).toFixed(2)}</td>
                                                <td className="pt-4">{Number(data.total_depositos).toFixed(2)}</td>
                                                <td className="pt-4">{Number(data.total_depositos_gerados).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex justify-between text-[12px] gap-6 items-center w-full mt-4">
                                <p className="text-[12px]">mostrando página {actualPage} de {pageCounts}</p>
                                <div className="flex">
                                    {startPage > 4 && (
                                        <button className="mx-1" onClick={handlePrevPages}>
                                            <svg width="8" height="8" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.92541 0.558058C7.19153 0.802136 7.19153 1.19786 6.92541 1.44194L2.4375 5.55806C2.17138 5.80214 2.17138 6.19786 2.4375 6.44194L6.92541 10.5581C7.19153 10.8021 7.19153 11.1979 6.92541 11.4419C6.65928 11.686 6.22781 11.686 5.96169 11.4419L1.47378 7.32583C0.675408 6.59359 0.675406 5.40641 1.47378 4.67418L5.96169 0.558058C6.22781 0.313981 6.65928 0.313981 6.92541 0.558058Z" fill="white" />
                                            </svg>


                                        </button>
                                    )}
                                    {pages.slice(startPage - 1, startPage + 3).map((page) => (
                                        <button key={page} className={`mx-1 ${page === actualPage ? 'bg-[#478DF8] p-1 px-2 rounded-[10px]' : ''}`} onClick={() => handlePageChange(page)}>
                                            {page}
                                        </button>
                                    ))}
                                    {startPage + 3 < pageCounts && (
                                        <button className="mx-1" onClick={handleNextPages}>
                                            <svg width="8" height="8" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.07459 11.4419C0.808469 11.1979 0.808469 10.8021 1.07459 10.5581L5.5625 6.44194C5.82863 6.19786 5.82863 5.80214 5.5625 5.55806L1.07459 1.44194C0.80847 1.19786 0.80847 0.802137 1.07459 0.558058C1.34072 0.313981 1.77219 0.313981 2.03831 0.558058L6.52622 4.67418C7.32459 5.40641 7.32459 6.59359 6.52622 7.32582L2.03831 11.4419C1.77219 11.686 1.34072 11.686 1.07459 11.4419Z" fill="white" />
                                            </svg>
                                        </button>
                                    )}


                                </div>
                            </div>
                        </>
                    }


                    {type === 'entries' || type === 'exits' && relatories === undefined && <>
                        <div className="flex items-center gap-4 mt-3">
                            {/* <div className="flex cursor-pointer text-white gap-3 items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                            <img src={qrCodeIcon} />
                            <p>Adicionar saldo</p>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                            </svg>
                        </div> */}
                            <div className="flex   gap-1 text-white items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                <img src={calendarIcon} />
                                <DatePicker selected={startDate} onChange={(date) => { setStartDate(date); getRelatorie(actualPage, date, endDate) }} className="bg-transparent w-[100px]  cursor-pointer  text-center text-white focus:outline-none" />
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                                </svg>
                            </div>
                            <div className="flex">
                                <svg width="10" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.5 1L0.5 4L3.5 7" stroke="white" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="10" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.500366 7L3.50037 4L0.500367 1" stroke="white" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div className="flex  gap-1 text-white items-center py-1 px-2 text-[13px] rounded-[10px] bg-[#478DF8]">
                                <img src={calendarIcon} />
                                <DatePicker selected={endDate} onChange={(date) => { setEndDate(date); getRelatorie(actualPage, startDate, date) }} className="bg-transparent w-[100px]  cursor-pointer  text-center text-white focus:outline-none" />
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64645 5.65967C3.84171 5.44678 4.15829 5.44678 4.35355 5.65967L7.64645 9.25C7.84171 9.4629 8.15829 9.4629 8.35355 9.25L11.6464 5.65968C11.8417 5.44678 12.1583 5.44678 12.3536 5.65968C12.5488 5.87257 12.5488 6.21775 12.3536 6.43065L9.06066 10.021C8.47487 10.6597 7.52513 10.6597 6.93934 10.021L3.64645 6.43065C3.45118 6.21775 3.45118 5.87257 3.64645 5.65967Z" fill="white" fill-opacity="0.4" />
                                </svg>
                            </div>
                        </div>
                        <div className="flex mt-6 items-center gap-4">
                            <p>Mostrando</p>
                            <div className="flex items-center bg-[#478DF8] text-[13px] px-2 rounded-[10px] p-1">
                                {/* <select className="bg-[transparent] focus:outline-none border-[none]">
                                <option>100</option>
                                <option>Todos</option>
                            </select> */}

                                10

                            </div>
                            <p>Registros</p>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full min-w-full overflow-x-auto gap-4 mt-4  gap-4 mt-4">
                                <thead className="text-[14px]  border-b border-[#343B4F] text-left w-full justify-between gap-3 items-center">
                                    <th>Id da transação</th>
                                    <th>Data gerada</th>
                                    <th>Valor</th>
                                    {type === 'entries' ? (
                                        <th>
                                            <div className="text-[#59A8D4] text-center p-1 w-[100px] rounded-[15px] bg-[#E2F5FF]">Status</div>
                                        </th>
                                    ) : (
                                        <>
                                            <th>
                                                <div className="text-[white] mb-1 p-1 w-[100px] rounded-[15px] bg-[#478DF8]">Comprovante</div>
                                            </th>
                                            <th>
                                                <div className="text-[white] mb-1 p-1 w-[100px] rounded-[15px] bg-[#478DF8]">Descrição</div>
                                            </th>
                                        </>
                                    )}

                                </thead>
                                <tbody className="min-w-full" style={{ paddingTop: '16px' }}>
                                    <tr className="text-[12px] pt-4 w-full border-[#343B4F]">
                                        <td className="pt-4"></td>
                                        <td className="pt-4"></td>
                                        <td className="pt-4"></td>
                                        <td className="pt-4"></td>
                                    </tr>
                                    {[].map((data) => (
                                        <tr key={data.id} className="text-[12px] pt-4 w-full border-[#343B4F]">
                                            {type === 'entries' ? (
                                                <td>{data.txtId}</td>
                                            ) : (
                                                <td>{data.endToEndId}</td>
                                            )}
                                            <td>
                                                {new Date(data.created_at).toLocaleString('pt-BR', {
                                                    timeZone: 'America/Sao_Paulo', // Define o fuso horário de Brasília
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false // Para usar o formato 24 horas
                                                })}
                                            </td>
                                            <td>{data.amount}</td>
                                            {type === 'entries' ? (
                                                <td>
                                                    <div className="text-[#59A8D4] text-center font-bold p-1 w-[100px] rounded-[15px] bg-[#E2F5FF]">{data.status ? 'aprovado' : 'pendente'}</div>
                                                </td>
                                            ) : (
                                                <td>
                                                    <div onClick={() => { handleComprovante(data) }} className="text-[#59A8D4] cursor-pointer ml-8 font-bold p-1 w-[100px] rounded-[15px] ">
                                                        <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.40625 5.0937H2.8125V8.8437H1.875C1.75068 8.8437 1.63145 8.89309 1.54354 8.981C1.45564 9.0689 1.40625 9.18813 1.40625 9.31245C1.40625 9.43677 1.45564 9.556 1.54354 9.64391C1.63145 9.73182 1.75068 9.7812 1.875 9.7812H13.125C13.2493 9.7812 13.3685 9.73182 13.4565 9.64391C13.5444 9.556 13.5938 9.43677 13.5938 9.31245C13.5938 9.18813 13.5444 9.0689 13.4565 8.981C13.3685 8.89309 13.2493 8.8437 13.125 8.8437H12.1875V5.0937H13.5938C13.6957 5.0936 13.7949 5.06024 13.8762 4.99867C13.9575 4.93711 14.0166 4.8507 14.0443 4.75256C14.0721 4.65442 14.0671 4.54991 14.0301 4.45487C13.9931 4.35983 13.9261 4.27945 13.8393 4.22593L7.74551 0.475929C7.67167 0.43053 7.58668 0.406494 7.5 0.406494C7.41332 0.406494 7.32833 0.43053 7.25449 0.475929L1.16074 4.22593C1.07392 4.27945 1.00693 4.35983 0.96992 4.45487C0.932912 4.54991 0.927912 4.65442 0.955677 4.75256C0.983442 4.8507 1.04246 4.93711 1.12377 4.99867C1.20508 5.06024 1.30426 5.0936 1.40625 5.0937ZM3.75 5.0937H5.625V8.8437H3.75V5.0937ZM8.4375 5.0937V8.8437H6.5625V5.0937H8.4375ZM11.25 8.8437H9.375V5.0937H11.25V8.8437ZM7.5 1.42515L11.9379 4.1562H3.06211L7.5 1.42515ZM14.5312 11.1875C14.5312 11.3118 14.4819 11.431 14.394 11.5189C14.306 11.6068 14.1868 11.6562 14.0625 11.6562H0.9375C0.81318 11.6562 0.693951 11.6068 0.606044 11.5189C0.518136 11.431 0.46875 11.3118 0.46875 11.1875C0.46875 11.0631 0.518136 10.9439 0.606044 10.856C0.693951 10.7681 0.81318 10.7187 0.9375 10.7187H14.0625C14.1868 10.7187 14.306 10.7681 14.394 10.856C14.4819 10.9439 14.5312 11.0631 14.5312 11.1875Z" fill="#478DF8" />
                                                        </svg>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="flex justify-between text-[12px] gap-6 items-center w-full mt-4">
                            <p className="text-[12px]">mostrando página {actualPage} de {pageCounts}</p>
                            <div className="flex">
                                {startPage > 4 && (
                                    <button className="mx-1" onClick={handlePrevPages}>
                                        <svg width="8" height="8" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.92541 0.558058C7.19153 0.802136 7.19153 1.19786 6.92541 1.44194L2.4375 5.55806C2.17138 5.80214 2.17138 6.19786 2.4375 6.44194L6.92541 10.5581C7.19153 10.8021 7.19153 11.1979 6.92541 11.4419C6.65928 11.686 6.22781 11.686 5.96169 11.4419L1.47378 7.32583C0.675408 6.59359 0.675406 5.40641 1.47378 4.67418L5.96169 0.558058C6.22781 0.313981 6.65928 0.313981 6.92541 0.558058Z" fill="white" />
                                        </svg>


                                    </button>
                                )}
                                {pages.slice(startPage - 1, startPage + 3).map((page) => (
                                    <button key={page} className={`mx-1 ${page === actualPage ? 'bg-[#478DF8] p-1 px-2 rounded-[10px]' : ''}`} onClick={() => handlePageChange(page)}>
                                        {page}
                                    </button>
                                ))}
                                {startPage + 3 < pageCounts && (
                                    <button className="mx-1" onClick={handleNextPages}>
                                        <svg width="8" height="8" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.07459 11.4419C0.808469 11.1979 0.808469 10.8021 1.07459 10.5581L5.5625 6.44194C5.82863 6.19786 5.82863 5.80214 5.5625 5.55806L1.07459 1.44194C0.80847 1.19786 0.80847 0.802137 1.07459 0.558058C1.34072 0.313981 1.77219 0.313981 2.03831 0.558058L6.52622 4.67418C7.32459 5.40641 7.32459 6.59359 6.52622 7.32582L2.03831 11.4419C1.77219 11.686 1.34072 11.686 1.07459 11.4419Z" fill="white" />
                                        </svg>
                                    </button>
                                )}


                            </div>
                        </div>
                    </>}
                </div>
            </div>
            <ComprovanteModal isOpen={comprovanteOpen} onClose={setComprovanteOpen} comprovanteData={comprovanteData} />
        </div>
    )
}

export default RelatorioPage